import { setBlockAction } from 'actions/setBlockAction';
import { cloneBlock, Block } from 'factories/block';
import { getAllTopicsOrdered } from 'selectors/block';

function updateLegacyBlocksWithSId(store) {
  const { blocks } = store.getState();
  const blocksList = Object.values(blocks) as Block[];

  const topicBlocks = getAllTopicsOrdered(blocks);

  const interactionBlocks = blocksList.filter(block => {
    return block.type.toLowerCase() === 'interaction';
  });

  const assessmentQuestionBlocks = blocksList.filter(block => {
    return block.type.toLowerCase() === 'AssessmentQuestion'.toLowerCase();
  });

  let topicBlocksSIdCounter = Math.max(
    ...topicBlocks.map(topicBlock => topicBlock?.props?.sId || 0)
  );

  let interactionBlocksSIdCounter = Math.max(
    ...interactionBlocks.map(
      interactionBlock => interactionBlock?.props?.sId || 0
    )
  );

  //
  let assessmentQuestionBlocksSIdCounter = Math.max(
    ...assessmentQuestionBlocks.map(assessmentQuestionBlock => {
      const sId = assessmentQuestionBlock?.props?.sId;

      return sId || 0;
    })
  );

  const blocksUpdatedWithSId = (blocks: Block[]) => {
    // filter out the blocks that HAVE sId
    return blocks
      .filter((block: Block) => {
        if (block.props) {
          const { sId } = block.props;
          return !sId;
        }
      })
      .map((block: Block) => {
        const nextBlock = cloneBlock(block);

        let sId;

        switch (nextBlock.type.toLowerCase()) {
          case 'topic': {
            topicBlocksSIdCounter += 1;
            sId = topicBlocksSIdCounter;
            break;
          }

          case 'interaction': {
            interactionBlocksSIdCounter += 1;
            sId = interactionBlocksSIdCounter;
            break;
          }

          case 'assessmentquestion': {
            assessmentQuestionBlocksSIdCounter += 1;
            sId = assessmentQuestionBlocksSIdCounter;
            break;
          }
        }

        nextBlock.props = {
          ...nextBlock.props,
          sId,
        };

        return nextBlock;
      });
  };

  const updateTopicPortalMediasWithSIds = () => {
    const TopicPortalContainers = blocksList.filter((block: Block) => {
      return block.type === 'TopicPortalContainer';
    });

    console.log(
      'update TopicPortalMedias with topicSId if required',
      TopicPortalContainers
    );

    const topicPortalMediasUpdatedWithSIds: Block[] = [];

    TopicPortalContainers.forEach(entry => {
      const topicPortalMedias = entry?.children as Block[];

      topicPortalMedias?.forEach((tPM, index) => {
        const tPMBlock = blocks[tPM?.id];
        //

        if (!tPMBlock) {
          return;
        }

        const nextTPMBlock = cloneBlock(tPMBlock);

        if (nextTPMBlock && !nextTPMBlock?.props?.topicSId) {
          //
          if (!nextTPMBlock?.props) {
            nextTPMBlock.props = {};
          }

          console.log(
            `TopicPortalMedia is missing topicSId. update : ${topicBlocks[index]?.props?.sId}`
          );

          nextTPMBlock.props.topicSId = topicBlocks[index]?.props?.sId;

          topicPortalMediasUpdatedWithSIds.push(nextTPMBlock);
        } else {
          console.log(`TopicPortalMedia has topicSId. DOES NOT NEED UPDATING`);
        }
      });
    });

    return topicPortalMediasUpdatedWithSIds;
  };

  const updatedBlocks = [
    ...blocksUpdatedWithSId(topicBlocks),
    ...blocksUpdatedWithSId(interactionBlocks),
    ...blocksUpdatedWithSId(assessmentQuestionBlocks),
    ...updateTopicPortalMediasWithSIds(),
  ];

  if (!updatedBlocks.length) {
    return;
  }

  updatedBlocks.forEach((block: Block) => {
    if (block) {
      store.dispatch(setBlockAction(block));
    } else {
      console.log(`WTF. ${block} is not a block !?!?`);
    }
  });
}

export { updateLegacyBlocksWithSId };
